module.exports = __webpack_public_path__ + "static/media/windsurfing_1600.8dd901ae.webp";